// Mobile detection + wallet in-app-browser deep links.
// On a normal mobile browser (no injected provider) we open the current dApp
// URL INSIDE the wallet's in-app browser, where the provider IS injected.
export const isMobile = () => /Android|iPhone|iPad|iPod/i.test(navigator.userAgent) ||
  (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

function target() {
  const u = new URL(window.location.href);
  return u;
}

export const walletDeepLinks = {
  metamask: () => {
    const u = target();
    return `https://link.metamask.io/dapp/${u.host}${u.pathname}${u.search}${u.hash}`;
  },
  coinbase: () => `https://go.cb-w.com/dapp?cb_url=${encodeURIComponent(target().href)}`,
  trust: () => `https://link.trustwallet.com/open_url?coin_id=60&url=${encodeURIComponent(target().href)}`,
  phantom: () => `https://phantom.app/ul/browse/${encodeURIComponent(target().href)}?ref=${encodeURIComponent(target().origin)}`,
  solflare: () => `https://solflare.com/ul/v1/browse/${encodeURIComponent(target().href)}?ref=${encodeURIComponent(target().origin)}`,
};

// Must be called synchronously from the user's tap (no awaited work before).
export function openWalletDapp(name) {
  const build = walletDeepLinks[name];
  if (!build) throw new Error("Unknown wallet");
  window.location.href = build();
}
